import { render, staticRenderFns } from "./C2P.vue?vue&type=template&id=4b654a60"
import script from "./C2P.vue?vue&type=script&lang=js"
export * from "./C2P.vue?vue&type=script&lang=js"
import style0 from "./C2P.vue?vue&type=style&index=0&id=4b654a60&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports